export const NAME_SEPARATOR = ' - ';

export const getSearchableCompanyName = (company) => {
    const displayName = company.displayName?.trim();
    return displayName ? displayName + company.name : company.name;
};

export const getCompanyDisplayName = (company) => {
    const displayName = formatDisplayName(company.displayName);
    return displayName
        ? `${displayName}${NAME_SEPARATOR}${company.name}`
        : company.name;
};

export const formatDisplayName = (displayName) => {
    const trimmed = displayName?.trim();
    return trimmed ? `"${trimmed}"` : null;
};
